'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

require('../styles/LibraryLogo.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LibraryLogo = function (_BcReactComponent) {
  _inherits(LibraryLogo, _BcReactComponent);

  function LibraryLogo() {
    _classCallCheck(this, LibraryLogo);

    return _possibleConstructorReturn(this, (LibraryLogo.__proto__ || Object.getPrototypeOf(LibraryLogo)).apply(this, arguments));
  }

  _createClass(LibraryLogo, [{
    key: 'getLogoUrl',
    value: function getLogoUrl() {
      var imageName = this.props.imageName || (this.props.small ? 'mobile_logo' : 'logo');
      return this.props.baseUrl + '/images/' + this.props.siteId + '/' + imageName + '.png';
    }
  }, {
    key: 'render',
    value: function render() {
      var classes = (0, _classnames2.default)('cp-library-logo', {
        'logo-small': this.props.small,
        'logo-circled': this.props.circled
      }, this.props.className);

      return _react2.default.createElement('img', { src: this.getLogoUrl(), className: classes, alt: this.props.alt });
    }
  }]);

  return LibraryLogo;
}(_baseBcReactComponent2.default);

LibraryLogo.propTypes = {
  siteId: _react.PropTypes.string.isRequired,
  small: _react.PropTypes.bool,
  circled: _react.PropTypes.bool,
  imageName: _react.PropTypes.string,
  baseUrl: _react.PropTypes.string,
  alt: _react.PropTypes.string,
  className: _react.PropTypes.string
};

LibraryLogo.defaultProps = {
  baseUrl: '',
  small: false,
  circled: false,
  alt: '' // Default to blank, assume it's decorative
};

exports.default = LibraryLogo;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/shared-library-logo/lib/components/LibraryLogo.component.js
// module id = 1490
// module chunks = 1